<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'ProductivityCard',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '0',
      rawVariation: '0',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    formatDotToComma(string) {
      return `${string.toFixed(2).toString().replace('.', ',')}%`;
    },
    ...mapActions('cards', [
      'getCallExportsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.getCallExportsService({
        itemId: this.itemId,
        servicePath: 'getOverallProductivityWithVariation',
        serviceParams: {
          operatorsIds: this.card.props.filter?.sac_replier?.value.toString(),
        },
      })
        .then(response => {
          this.value = this.formatDotToComma(response.currentValue);
          this.comparationValue = this.formatDotToComma(response.previousValue);
          this.variation = response.productivityVariation;
          this.rawVariation = response.productivityVariation;
          this.requestStatus = 'success';

          if (this.$attrs.filter) {
            this.filter = this.$attrs.filter;
          }

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
